// @vendors
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const moment = require('moment');
const Immutable = require('immutable');

// @actions
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const brokerIntervenerActions = require('actions/brokerInterveners');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');
const { keepAlive } = require("actions/logout");

// @utils
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');
const mifidErrorHelper = require('mifid/utilities/mifidErrorHelper');
const { downloadAsFile } = require('utilities/APIRequestHelper');
const { openBase64pdfInNewTab } = require('utilities/pdfDocumentsHelper')
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');
const { getURL } = require('core/apiURLBuilder');

// @constants
const {
    CHARGE_ACCOUNT_PREFIX,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    EURO_TEXT,
    BROKER_WARRANTS_BUY_BUYFOR_AMOUNT,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    DATE_FORMAT_API,
    BROKER_CATEGORY_WARRANT,
    BROKER_DOCUMENT_TYPE,
    BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID,
    BROKER_ORDER_TYPE_BUY,
    CONNECTION_CHANNEL_INTERNET,
    CONNECTION_CHANNEL_INTRANET,
    BROKER_PRODUCT_TYPE_WARRANTS,
    BROKER_MIFID_VERSION_2,
    INTERVENER_TYPE_PROPIETARIO,
    CONTENT_TYPE_PDF,
    API_CHANNEL
} = require('constants/index');

const actionTypes = require('constants/actionTypes');

// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @Contact Center
const config = require('core/environmentConfig');

function reset() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function stockContractChanged(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_STOCK_CONTRACT_CHANGED,
        payload: {
            value
        }
    };
}

function buyForOptionChanged(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_BUYFOR_OPTION_CHANGED,
        payload: {
            value
        }
    };
}

function performBuyForValueChanged(buyPrice, value) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_BUYFOR_VALUE_CHANGED,
        payload: {
            productPrice: buyPrice,
            value
        }
    };
}

const buyForValueChanged = (value) => (dispatch, getState) => {
    const brokerProductFile = getState().brokerProductFile;
    dispatch(performBuyForValueChanged(brokerProductFile.get('buyPrice'), value));
};

function buyForValueReset(productPrice) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_BUYFOR_VALUE_RESET,
        payload: {
            productPrice: productPrice
        }
    };
}

function limitPriceChanged(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_LIMIT_PRICE_CHANGED,
        payload: {
            value
        }
    };
}

function validationSuccess(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function validationFailure(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    };
}

function validationRequest() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_VALIDATE_REQUEST
    };
}

function confirmationSuccess(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    };
}

function confirmationFailure(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

function confirmationRequest() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_CONFIRM_REQUEST
    };
}

function sendOrderSummaryEmailRequest() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_SEND_EMAIL_REQUEST
    };
}

function sendOrderSummaryEmailSuccess() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_SEND_EMAIL_SUCCESS
    };
}

function sendOrderSummaryEmailError() {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_SEND_EMAIL_ERROR
    };
}

const resetLeaglConfirmationMail = () => ({
    type: actionTypes.BROKER_WARRANTS_BUY_LEGAL_MAIL_RESET
});

const LeaglConfirmationMailToClientSuccess = () => ({
    type: actionTypes.BROKER_WARRANTS_BUY_LEGAL_MAIL_SENT_SUCCESS
});

const LeaglConfirmationMailToClientRequest = () => ({
    type: actionTypes.BROKER_WARRANTS_BUY_LEGAL_MAIL_SENT_REQUEST
});

const LeaglConfirmationMailToClientFailure = (error) => ({
    type: actionTypes.BROKER_WARRANTS_BUY_LEGAL_MAIL_SENT_FAILURE,
    payload: {
        error
    }
});

const getUrlForDFIDocument = ({market, isin, isMedysifProvider}) => {
    const url = isMedysifProvider ? apiURLBuilder.getURL('getKidsDocumentForWarrant', { market, isin, docType:'KID' })
    : getURL('kidDocumentPdf', { warrantIsin: isin });
    return url;
}

const sendLeaglConfirmationMail = (inputData) => (dispatch, getState) => {
    const immBrokerProductFile = getState().brokerProductFile;
    const immFeatureFlags = getState().flagBasedFeatures;
    const exantCostsData = getState().brokerWarrantsBuy.get('exAnteCostsList');
    const showExantCostWarrantsBuy = immFeatureFlags.get('wealth_warrants_buy_show_costs')
    const marketName = immBrokerProductFile.get('marketName') || "";
    const costYield = exantCostsData
        ? ""
        : getState().brokerWarrantsBuy.get("WarrantsTransactionCostObjectId");
    const dfiExists = getState().brokerWarrantsBuy.get('dfiExists');
    const isin = immBrokerProductFile.get('isinCode');
    const isMedysifProvider = immFeatureFlags.get('wealth_medysif_warrant_provider');
    const market = immBrokerProductFile.getIn(['warrant', 'micCode']);
    const url = getUrlForDFIDocument({market, isin, isMedysifProvider});
    const fundamentalDataForInvestorUrl = dfiExists ? url : '';

    const communicationServiceInput = {
        "channel": CONNECTION_CHANNEL_INTRANET,
        "email": inputData.clientEmail,
        "sendOrder": "Yes",
        "saveDocumentation": "no",
        "productKID": fundamentalDataForInvestorUrl,
        "contract": "",
        "marketingReport": "",
        "infoCcs": "",
        "costYield": costYield,
        "clientAlias": "",
        "isin": immBrokerProductFile.get('isinCode'),
        "isinDescribe": immBrokerProductFile.get('companyName'),
        "orderType": BROKER_ORDER_TYPE_BUY,
        "productType": BROKER_PRODUCT_TYPE_WARRANTS,
        "idOrder": "",
        "holders": "",
        "ccc": "",
        "ccv": "",
        "market": marketName,
        "sharesNumber": "",
        "orderCondition": "",
        "sharesAmount": "",
        "termValidity": "",
        "conditionPrize": "",
        "currency": "",
        "mifidWarningText": "",
        "dateTime": ""
    };
    let requestData;
    if (showExantCostWarrantsBuy) {
        requestData = {
            query: communicationServiceInput,
            exAnteCostsList: exantCostsData
        };
    } else {
        requestData = {
            query: communicationServiceInput
        };
    }

    dispatch(LeaglConfirmationMailToClientRequest())
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData)
        .then(() => dispatch(LeaglConfirmationMailToClientSuccess()))
        .catch(error => dispatch(LeaglConfirmationMailToClientFailure(error)))
}

function warrantsBuyFinish(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_FINISH,
        payload: {
            data: get(response, 'timestamp', '')
        }
    }
}

function getValidationData(getState) {
    const validationData = {
        'descripcionRestriccion': BROKER_STOCKS_BUY_NO_RESTRICTION,
        'tipoNegociacion': '0',
        'tipoRestriccion': '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const operationFirstStep = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP]);
    const orderType = operationFirstStep.get('orderTypeOption');
    const validityDate = operationFirstStep.get('validityDate');
    const buyFor = operationFirstStep.get('buyForOption');

    if (buyFor === BROKER_WARRANTS_BUY_BUYFOR_AMOUNT) {
        validationData['importeAprximado'] = {
            'divisa': EURO_TEXT,
            'importe': operationFirstStep.get('buyForValue')
        };

        if (operationFirstStep.get('titleQuantity')) {
            // comes from validation service "titulosImporteAproximado"
            // only if setted after initial validation // @TODO define if this is correct - it fixes buy for approx import confirmation
            validationData['numTitulos'] = operationFirstStep.get('titleQuantity');
        }

    } else {
        validationData['numTitulos'] = operationFirstStep.get('buyForValue');
    }

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            'divisa': EURO_TEXT,
            'numeroimportevalores': operationFirstStep.get('orderTypeValue')
        };
    } else {
        validationData['importeLimitada'] = {
            'divisa': EURO_TEXT,
            'numeroimportevalores': 0
        };
    }

    validationData['tipoOrden'] = orderTypes[orderType].code;
    validationData['descripcionOrden'] = orderTypes[orderType].orderDescription;
    validationData['plazoValidez'] = validityDate.format(DATE_FORMAT_API);

    return validationData;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const sendOrderSummaryEmail = (response) => (dispatch, getState) => {
    let communicationServiceInput, data;
    const immProfile = getState().profile;
    const immBrokerWarrantsBuy = getState().brokerWarrantsBuy;
    const immFeatureFlags = getState().flagBasedFeatures;
    const immBrokerProductFile = getState().brokerProductFile;
    const dataValidation = getValidationData(getState);
    const selectedOption = immBrokerWarrantsBuy.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.get(selectedOption);
    const controlDigit = contract.get('controlDigit');
    const productNumber = contract.get('productNumber');
    const walletNumber = contract.get('walletNumber');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${walletNumber}`;
    const emittedDateTime = moment(parseInt(get(response, 'timestamp', '')));
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const costYieldObjectId = immBrokerWarrantsBuy.get('WarrantsTransactionCostObjectId');
    const dfiExists = immBrokerWarrantsBuy.get('dfiExists');
    const isMedysifProvider = immFeatureFlags.get('wealth_medysif_warrant_provider');
    const market = immBrokerProductFile.getIn(['warrant', 'micCode']);
    const url = getUrlForDFIDocument({isin: immBrokerProductFile.get('isinCode'), isMedysifProvider, market})
    const fundamentalDataForInvestorUrl = dfiExists ? url : '';
    const limitPrice = immBrokerWarrantsBuy.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
    const showExantCostWarrantsBuy = immFeatureFlags.get('wealth_warrants_buy_show_costs');
    const immExAnteCostObject = immBrokerWarrantsBuy.get('exAnteCostsList');
    const exAnteCostsList =
        !!immExAnteCostObject && !!immExAnteCostObject.get("exAnteCostList")
            ? translateExantCostKey(
                immExAnteCostObject.get("exAnteCostList").toJS(),
                "brokerWarrantBuy"
            ) : null;
    const confirmationData = immBrokerWarrantsBuy.get('confirmationData');
    const importe = showExantCostWarrantsBuy
        ? confirmationData.titulosImporteAproximado
        : "";
    const marketName = showExantCostWarrantsBuy
        ? immBrokerProductFile.get("micCode")
        : immBrokerProductFile.getIn(["warrant", "marketplace"], "").trim();

    communicationServiceInput = {
        "email": PersonalDataHelper.getEmail(immProfile),
        "productKID": fundamentalDataForInvestorUrl,
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "costYield": !!costYieldObjectId && !showExantCostWarrantsBuy
            ? costYieldObjectId
            : "",
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": getState().brokerProductFile.get('isinCode'),
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "idOrder": get(response, 'numeroOrden', ''),
        "channel": CONNECTION_CHANNEL_INTERNET,
        "orderType": BROKER_ORDER_TYPE_BUY,
        "productType": BROKER_PRODUCT_TYPE_WARRANTS,
        "holders": holderNames.join(','),
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], ''),
        "ccv": securityAccount,
        "idContract": securityAccount,
        "market": marketName,
        "sharesNumber": "" + dataValidation.numTitulos,
        "orderCondition": dataValidation.descripcionOrden,
        "sharesAmount": importe,
        "termValidity": dataValidation.plazoValidez,
        "conditionPrize": "" + limitPrice,
        "currency": get(response, ['datosCuentaAsociada', 'saldoCuentaAsociada', 'divisa'], ''),
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest),
        "dateTime": emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME)
    };

    if (showExantCostWarrantsBuy) {
        data = {
            query: {
                ...communicationServiceInput,
                exAnteCostsList: exAnteCostsList
            }
        };
    } else {
        data = {
            query: communicationServiceInput
        };
    }

    dispatch(sendOrderSummaryEmailRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), data).then(
        function () {
            dispatch(sendOrderSummaryEmailSuccess());
        },
        function () {
            dispatch(sendOrderSummaryEmailError());
        }
    );
}

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers =
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers'])
                .merge(immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']))
                .toJS();

        disclaimers = reduce(mifidv2AllDisclaimers, (result, disclaimer, index) => {
            const disclaimerKey = `disclaimer_${index + 1}`;
            let disclaimerText;
            if (index === 0 && !!get(disclaimer, 'phrase')){
                disclaimerText = `${trim(get(disclaimer, 'description'))} ${get(disclaimer, 'phrase')}`
            } else{
                disclaimerText = trim(get(disclaimer, 'description'));
            }

            result[disclaimerKey] = `${trim(get(disclaimer, 'id'))} | ${disclaimerText}`;

            return result;
        }, {});
    }

    return disclaimers;
};

const confirmWarrantsBuy = (dataToken, history) => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP]);
    const confirmationData = getState()['brokerWarrantsBuy'].get('confirmationData');
    const executionData = confirmationData.datosEjecucion;
    const emitData = confirmationData.datosEmision;
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const isSpain = isinCode.substr(0, 2).toLowerCase() === 'es';
    const shares = get(confirmationData, 'titulosImporteAproximado');
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID, 'codigoDisclaimer']);

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const mifidScore = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'score']);
    const mifidScoring = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoring']);
    const mifidWasApplied = immBrokerConvenienceMiFIDTest.get('started');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const data = {
        'contratoValores': {
            'numerodecontrato': contract.get('walletNumber'),
            'producto': contract.get('productNumber')
        },
        'dataToken': dataToken,
        'datosEjecucion': {
            'codigoGrupoSector': executionData.codigoGrupoSector,
            'codigoOrganismoEjecucion': executionData.codigoOrganismoEjecucion,
            'codigoValorJuntSind': executionData.codigoValorJuntSind,
            'codvalorSib': executionData.codvalorSib,
            'indicadorCompensacion': executionData.indicadorCompensacion,
            'indicadorContingencia': executionData.indicadorContingencia,
            'indicadorEnvioRecepcion': executionData.indicadorEnvioRecepcion,
            'nominalTitulo': {
                'divisa': executionData.nominalTitulo.divisa,
                'importe': executionData.nominalTitulo.importe
            },
            'tipoCotizacion': executionData.tipoCotizacion,
            'tipoMercado': executionData.tipoMercado,
            'tipoOperacion': 'C',
            'titulosNominalMinEjec': 0,
            'tratamientoEmision': executionData.tratamientoEmision
        },
        'datosEmision': {
            'codEmision': emitData.codEmision,
            'codMercado': emitData.codMercado,
            'codValor': emitData.codValor
        },
        'datosValidacion': getValidationData(getState),
        "convenienceTest": codigoDisclaimer,
        "productIsin": isinCode,
        "productType": BROKER_CATEGORY_WARRANT,
        "shares": shares,
        "initQuantity": shares,
        "unitPrice": immBrokerProductFile.getIn(['productValue', 'amount']),
        "productManager": immBrokerProductFile.get('manager'),
        "micCode": micCode,
        "convenientRegistry": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'isConvenient']),
        "evaluateRegistry": mifidWasApplied,
        "disclaimers": mifidDisclaimersResponse(immBrokerConvenienceMiFIDTest),
        "marketTargetRegistry": mifidScore >= mifidScoring,
        "necessaryConvenienceTestNote": mifidScoring,
        "necessaryTargetMarketNote": immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'targetMarketKnowledgeAndExperience']),
        "testConveniencyResult": mifidScore,
        "documentationId": uuid
    };

    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        header: {
            version: 2
        },
        query: data
    };
    return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData)
        .then(function (response) {
            dispatch(keepAlive(false));
            dispatch(sendOrderSummaryEmail(response));
            dispatch(confirmationSuccess(response));
            dispatch(warrantsBuyFinish(response));
            dispatch(outdateGlobalPosition());
            dispatch(outdateMyInvestments());
        }, function (response) {
            dispatch(confirmationFailure(response));
            dispatch(brokerStocksOperationFailure(response, history));
        }
        );
};

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

const onValidSignaturePattern = (dispatch, getState, dataToken, history) => {
    dispatch(signaturePatternSuccess(dataToken));
    dispatch(confirmWarrantsBuy(dataToken, history));
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(onValidSignaturePattern(dispatch, getState, dataToken, history))
    }

    signaturePatternActions.validateAndExecute(dispatch, getState, callback).catch(
        (error) => dispatch(confirmationFailure(error))
    );
};

const finish = (history) => (dispatch, getState) => {
    const secondStepValid = getState()['brokerWarrantsBuy'].getIn(['steps', SECOND_STEP, 'valid']);
    const secondStepLoading = getState()['brokerWarrantsBuy'].getIn(['steps', SECOND_STEP, 'loading']);

    if (secondStepValid && !secondStepLoading) {
        dispatch(confirmationRequest());
        dispatch(requestSignaturePatternValidation(history));
    }
};

function validateUIStep(step) {
    return {
        type: actionTypes.BROKER_WARRANTS_BUY_VALIDATE_STEP,
        payload: {
            step
        }
    };
}

const getInterveners = () => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP]);
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.get(selectedOption);

    const wallet = Immutable.fromJS({
        accountNumber: contract.get('walletNumber'),
        product: contract.get('productNumber')
    })
    dispatch(brokerIntervenerActions.getIndexes(wallet));
}

const validateWithAPI = (history) => (dispatch, getState) => {
    const operationFirstStep = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP]);

    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const isinCode = getState().brokerProductFile.get('warrant').get('instrumentId');
    const micCode = getState().brokerProductFile.get('warrant').get('micCode');
    const contract = getState().brokerStocksContract.get(selectedOption);

    const requestData = {
        'codigoISIN': isinCode,
        'codigoISO': micCode,
        'contratoValores': {
            'numerodecontrato': contract.get('walletNumber'),
            'producto': contract.get('productNumber')
        },
        'datosValidacion': getValidationData(getState),
        'digitoControl': contract.get('controlDigit'),
        'discriminadorClausula': 'N',
        'tipoOperacion': 'C'
    };

    dispatch(validationRequest());

    return APIPost(dispatch, apiURLBuilder.getURL('stocksSimpleBuyValidation'), { query: requestData })
        .then(function (response) {
            dispatch(validationSuccess(response));
            dispatch(getInterveners());
        }, function (response) {
            dispatch(validationFailure(response));
            const errorKey = get(response, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
        );
};

const consumeDFIDocumentService = (
    { warrantIsin, market, docType = 'KID', prepareForDownload = false }
) => (dispatch, getState) => {
    const immFeatureFlags = getState().flagBasedFeatures;
    const isMedysifProvider = immFeatureFlags.get('wealth_medysif_warrant_provider');
    const url = isMedysifProvider ? apiURLBuilder.getURL('getKidsDocumentForWarrant', { market, isin: warrantIsin, docType })
        : apiURLBuilder.getURL('kidDocumentPdf', { warrantIsin });
    let request = {};

    // Do not always include responseType, otherwise it will
    // throw a runtime exception if not handled properly
    if (prepareForDownload) {
        request.header = {
            responseType: 'arraybuffer'
        };
    }

    return APIGet(dispatch, url, request);
};

const validateExistingDFIDocument = () => (dispatch, getState) => {
    const warrantIsin = getState().brokerProductFile.getIn(['warrant', 'instrumentId']);
    const market = getState().brokerProductFile.getIn(['warrant', 'micCode']);
    return dispatch(consumeDFIDocumentService({warrantIsin, market}));
};

const fetchDFIfail = () => ({
    type: actionTypes.BROKER_WARRANTS_BUY_FETCHING_DFI_FAILED,
})

const fetchDFISuccess = (data) => ({
    type: actionTypes.BROKER_WARRANTS_BUY_FETCHING_DFI_SUCCESS,
    payload: data,
})

const validateStep = (step, history) => (dispatch, getState) => {
    dispatch(validateUIStep(step));

    switch (step) {
        case WIZARD_FIRST_STEP:
            const firstStepValid = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP, 'valid']);
            const firstStepLoading = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP, 'loading']);

            if (firstStepValid && !firstStepLoading) {
                dispatch(validateExistingDFIDocument()).then(
                    (response) => {
                        dispatch(fetchDFISuccess(response));
                        dispatch(validateWithAPI(history));
                    },
                    (error) => {
                        dispatch(fetchDFIfail());
                        const errorKey = get(error, ["body", "error"], "");
                        dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
                    }
                );
            }

            break;
        case WIZARD_SECOND_STEP:
            const secondStepValid = getState()['brokerWarrantsBuy'].getIn(['steps', SECOND_STEP, 'valid']);
            const secondStepLoading = getState()['brokerWarrantsBuy'].getIn(['steps', SECOND_STEP, 'loading']);

            if (secondStepValid && !secondStepLoading) {
                dispatch(finish(history));
            }

            break;
    }
};

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WARRANTS_SUBSCRIPTION_CHANGE_READCHECKED,
    payload: {
        checked
    }
});

const changeWarningOperationChecked = () => ({
    type: actionTypes.BROKER_WARRANTS_SUBSCRIPTION_CHANGE_WARNING_OPERATION_CHECKED,
});


const fetchWarrantsCostSuccess = (response) => ({
    type: actionTypes.BROKER_WARRANTS_LEGAL_DOCUMENT_COST_FETCH_SUCCESS,
    payload: { response }
});

const fetchWarrantsCostError = (error) => ({
    type: actionTypes.BROKER_WARRANTS_LEGAL_DOCUMENT_COST_FETCH_ERROR,
    payload: { error }
});

const fetchWarrantsCostRequest = () => ({
    type: actionTypes.BROKER_WARRANTS_LEGAL_DOCUMENT_COST_FETCH,
    payload: {}
});

function extantCostFeching() {
    return {
        type: actionTypes.BROKER_WARRANT_EXANTCOST_FECHING,
    };
}

function extantCostSuccess(data) {
    return {
        type: actionTypes.BROKER_WARRANT_EXANTCOST_SUCESS,
        payload: data
    };
}

function extantCostError(error) {
    return {
        type: actionTypes.BROKER_WARRANT_EXANTCOST_ERROR,
        payload: error
    };
}

const getExtantCostBuyWarrant = (history) => (dispatch, getState) => {
    const immStepOne = getState()['brokerWarrantsBuy'].getIn(['steps', FIRST_STEP])
    const immOrderType = immStepOne.getIn(['orderTypeOption']);
    let orderType = '';
    let limitedPrice = null;
    let sharesAmount = null;
    let sharesNumber = null;

    const buyForOption = immStepOne.getIn(['buyForOption']);

    if (buyForOption === "amount") {
        sharesAmount = {
            amount: immStepOne.getIn(['buyForValue']),
            currency: getState().brokerProductFile.get('currencyCode'),
            descriptionKey: null,
            percentage: null,
            tooltipKey: null,
            type: null
        }
    } else if (buyForOption === 'titles') {
        sharesNumber = immStepOne.getIn(['buyForValue']);
    }

    switch (immOrderType) {
        case 'toMarket':
            orderType = 'MARKET';
            break;
        case 'forTheBest':
            orderType = 'BEST';
            break;
        case 'limited':
            orderType = 'LIMITED';
            limitedPrice = {
                amount: immStepOne.getIn(['orderTypeValue']),
                currency: getState().brokerProductFile.get('currency'),
                descriptionKey: null,
                percentage: null,
                tooltipKey: null,
                type: null
            }
            break;
    }

    const selectedOption = immStepOne.getIn(['stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.get(selectedOption);

    const data = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: contract.get('walletNumber'),
            product: contract.get('productNumber')
        },
        instrumentType: 'WARRANT',
        isin: getState().brokerProductFile.get('isinCode'),
        limitedPrice,
        market: getState().brokerProductFile.get('micCode'),
        operationType: 'C',
        orderType,
        sharesAmount,
        sharesNumber
    }

    dispatch(extantCostFeching());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), { query: data }).then(
        function (response) {
            dispatch(extantCostSuccess(response));
        },
        function (error) {
            dispatch(extantCostError(error));
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    );
}

const getWarrantTransactionDocumentContent = (objectID, mifidErrorDatePassed) => (dispatch) => {
    const data = {
        query: {
            objectId: objectID
        }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('getDocumentContent'), data).then(response => {
        if (response && !!response.content) {
            const result = {
                objectId: objectID,
                content: response.content
            };
            dispatch(fetchWarrantsCostSuccess(result));
        } else {
            if (mifidErrorDatePassed) {
                dispatch(fetchWarrantsCostError(response));
            }
        }
    }, (error) => {
        if (mifidErrorDatePassed) {
            dispatch(fetchWarrantsCostError(error));
        }
    }
    );
};

const downloadDFIDocument =
  (productIsin, history, documentName = `warrant_${productIsin}`) =>
  (dispatch, getState) => {
    const prepareForDownload = __CONTACT_CENTER__ ? false : true;
    const immBrokerProductFile = getState().brokerProductFile;
    const immFeatureFlags = getState().flagBasedFeatures;
    const isMedysifProvider = immFeatureFlags.get('wealth_medysif_warrant_provider');
    const market = immBrokerProductFile.getIn(['warrant', 'micCode']);

    dispatch(
      consumeDFIDocumentService({ warrantIsin: productIsin, market, prepareForDownload })
    ).then(
      response => {
        const documentContent = isMedysifProvider ? response.content : get(response, 'xhr.response');
        if (__CONTACT_CENTER__) {
          if (isMedysifProvider) {
            openBase64pdfInNewTab(documentContent);
          } else {
            const url = getUrlForDFIDocument({ market, isin: productIsin, isMedysifProvider });
            window.open(url, '_blank');
          }
        } else {
          downloadAsFile(documentContent, CONTENT_TYPE_PDF, `${documentName}.pdf`);
        }
      },
      () => dispatch(errorActions.show('', true, history))
    );
  };

const getPublicDFIDocumentURL = (warrantIsin) => {
    const host = config.baseHostPrivada;
    let endpoint = config.services.endpoints['kidDocumentPdf'];
    endpoint = endpoint.replace(`{warrantIsin}`, warrantIsin);

    return `${host}${endpoint}`;
}

const fetchDFIDocument = (warrantIsin) => {
    const url = __CONTACT_CENTER__ ? getPublicDFIDocumentURL(warrantIsin) : apiURLBuilder.getURL('kidDocumentPdf', { warrantIsin });

    return {
        type: actionTypes.BROKER_WARRANTS_BUY_DFI_DOCUMENT_FETCH_SUCCESS,
        payload: { url }
    };
};

const fetchWarrantTransactionCost = (productIsin) => (dispatch, getState) => {
    dispatch(fetchDFIDocument(productIsin));
    const immAccessKey = getState().accessKeyChange;
    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(lastAccess);
    dispatch(fetchWarrantsCostRequest());

    const data = {
        "documentType": BROKER_DOCUMENT_TYPE,
        "isin": productIsin,
        "orderType": BROKER_ORDER_TYPE_BUY
    };

    const requestData = {
        query: data
    };

    return APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
        (response) => {
            if (response && response.objectId) {
                dispatch(getWarrantTransactionDocumentContent(response.objectId, mifidErrorDatePassed));
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(fetchWarrantsCostError(response))
                }
            }
        },
        (error) => {
            if (mifidErrorDatePassed) {
                dispatch(fetchWarrantsCostError(error));
            }
        }
    );
};

const setDocumentsRead = () => (dispatch) => dispatch({
    type: actionTypes.BROKER_WARRANTS_BUY_DOCUMENTS_READ
});

module.exports = {
    reset,
    setVisibleStep,
    validateStep,
    finish,
    setWillCancel,
    stockContractChanged,
    buyForOptionChanged,
    buyForValueChanged,
    buyForValueReset,
    limitPriceChanged,
    changeReadChecked,
    changeWarningOperationChecked,
    fetchWarrantTransactionCost,
    downloadDFIDocument,
    sendLeaglConfirmationMail,
    resetLeaglConfirmationMail,
    setDocumentsRead,
    getExtantCostBuyWarrant
};
